import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cell-hyperlink-custom',
  templateUrl: './cell-hyperlink-custom.component.html',
  styleUrls: ['./cell-hyperlink-custom.component.css']
})
export class CellHyperlinkCustomComponent implements OnInit {

  public params: any;


  constructor() {  }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;

    if (this.params.destUrl === undefined) {
      this.params.destUrl = '/';
    } else {
      this.params.destUrl = this.params.destUrl + this.params.value;
    }
    if (this.params.hyperlinkText === undefined) {
      this.params.hyperlinkText = 'Editar';
    }
    if (this.params.iconClass === undefined) {
      this.params.iconClass = 'fas fa-edit';
    }
  }
}
